import React from 'react';
import './App.scss';

function Footer() {
  return (
    <>
      <h5>LUIZ CLAUDIO</h5>
      <div>
        <ul>
          <li>
            <a href="#home">Home</a>
          </li>
          <li>
            <a href="#experience">Experiences</a>
          </li>
          <li>
            <a href="#projects">Projects</a>
          </li>
          <li>
            <a href="#contact">Contact</a>
          </li>
        </ul>
      </div>
      <span>© Luiz Claudio. All rights reserved.</span>
    </>
  );
}

export default Footer
  ;
